export default __webpack_public_path__ + "static/media/logo.013314c8.png";